import { createPageApp } from '@/lib/createPageApp'
import StudyInJoyArticleViewPage from './StudyInJoyArticleViewPage.vue'

createPageApp(StudyInJoyArticleViewPage).mount()
